import { render } from "./foodBatchData.vue?vue&type=template&id=51c01788&scoped=true"
import script from "./foodBatchData.vue?vue&type=script&lang=js"
export * from "./foodBatchData.vue?vue&type=script&lang=js"

import "./foodBatchData.vue?vue&type=style&index=0&id=51c01788&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c01788"]])

export default __exports__